export default __webpack_public_path__ + "static/media/hair-spa.d5fedd15.jpg";